module.exports = __webpack_public_path__ + "img/share-scrips.f7e0c87e.svg";